export default __webpack_public_path__ + "static/media/paleo_burrito.c87d6b8c.jpg";